import { createFeature, createReducer, on } from '@ngrx/store';
import { PushNotificationsActions } from './push-notifications.actions';

export const pushNotificationsFeatureKey = 'pushNotifications';

export interface PushNotificationsState {
  data: any | null;
  lastFileName: string | null;
  loading: boolean;
  error: any;
}

const initialState: PushNotificationsState = {
  data: null,
  lastFileName: null,
  loading: false,
  error: null,
};

export const pushNotificationsFeature = createFeature({
  name: pushNotificationsFeatureKey,
  reducer: createReducer(
    initialState,

    on(PushNotificationsActions.uploadCsv, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),

    on(PushNotificationsActions.uploadCsvSuccess, (state, { data, fileName }) => ({
      ...state,
      data,
      lastFileName: fileName,
      loading: false,
      error: null,
    })),

    on(PushNotificationsActions.uploadCsvFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),

    on(PushNotificationsActions.loadLatestUpload, (state) => ({
      ...state,
      loading: true,
    })),

    on(PushNotificationsActions.loadLatestUploadSuccess, (state, { data }) => ({
      ...state,
      lastFileName: data?.context?.fileName || null,
      loading: false,
    })),
    on(PushNotificationsActions.loadLatestUploadFailure, (state) => ({
      ...state,
      loading: false,
    })),
    on(PushNotificationsActions.deleteUpload, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),

    on(PushNotificationsActions.deleteUploadSuccess, (state) => ({
      ...state,
      data: null,
      lastFileName: null,
      loading: false,
      error: null,
    })),

    on(PushNotificationsActions.deleteUploadFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),

    on(PushNotificationsActions.resetState, () => initialState)
  ),
});